import React from 'react'
import PropTypes from 'prop-types'

import env from 'lib/env';
const { GOOGLE_RECAPTCHA_SITE_KEY } = env();

const propTypes = {
  action: PropTypes.string,
  rerenderParent: PropTypes.func.isRequired,
}

const defaultProps = {
  action: '',
};

class GoogleRecaptcha extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: false,
      token: null,
    };

    this.handleOnError = this.handleOnError.bind(this);
    this.handleOnExpired = this.handleOnExpired.bind(this);
    this.handleOnSuccess = this.handleOnSuccess.bind(this);

    this.recaptcha = React.createRef();
    this.createdCaptcha = null;
  }

  componentDidMount() {
    grecaptcha.enterprise.ready(() => {
      this.createdCaptcha = grecaptcha.enterprise.render(this.recaptcha.current, {
        'action': this.props.action,
        'callback' : this.handleOnSuccess,
        'error-callback' : this.handleOnError,
        'expired-callback' : this.handleOnExpired,
        'sitekey' : GOOGLE_RECAPTCHA_SITE_KEY,
      });
    });
  }

  get isValid() {
    return this.state.isValid;
  }

  get token() {
    return this.state.token;
  }

  handleOnSuccess(token) {
    this.setState({ token: token, isValid: true });
    this.props.rerenderParent();
  }

  handleOnExpired() {
    this.setState({ token: null, isValid: false });
    this.props.rerenderParent();
  }

  handleOnError() {
    this.setState({ token: null, isValid: false });
    this.props.rerenderParent();
  }

  invalidate() {
    grecaptcha.enterprise.reset(this.createdCaptcha);
    this.setState({ token: null, isValid: false });
    this.props.rerenderParent();
  }

  render() {
    return <div className="margin-bottom-20">
      <div ref={this.recaptcha}></div>
    </div>
  }
}

GoogleRecaptcha.propTypes = propTypes;
GoogleRecaptcha.defaultProps = defaultProps;

export default GoogleRecaptcha;
